import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function SvedenNavigation() {
  const { settingsOrg } = useSelector((state) => state.settingsOrg);
  const { asPath } = useRouter();
  const currentPath = asPath.split(/[?#]/)[0];
  const sections = settingsOrg?.pages?.[0]?.children?.find((item) => item.slug === "sveden")?.children || [];

  return (
    <nav className="sveden-navigation" aria-label="Подразделы сведений об образовательной организации">
      <Link href="/sveden">Все сведения об образовательной организации</Link>
      {sections.length > 0 && (
        <details>
          <summary>Перейти к подразделу</summary>
          <ul>
            {sections.filter((item) => item.title && item.url?.startsWith("/sveden/")).map((item) => (
              <li key={item.url}>
                <Link href={item.url} aria-current={currentPath === item.url ? "page" : undefined}>{item.title}</Link>
              </li>
            ))}
          </ul>
        </details>
      )}
      <style jsx>{`
        .sveden-navigation { margin-bottom: 32px; padding: 24px 40px; border-bottom: 1px solid #ddd; }
        details { margin-top: 16px; }
        summary { cursor: pointer; padding: 8px 0; font-weight: 600; }
        ul { columns: 2; gap: 32px; padding-left: 24px; margin: 16px 0 0; }
        li { break-inside: avoid; padding-bottom: 12px; }
        @media (max-width: 767px) { .sveden-navigation { padding: 20px; } ul { columns: 1; } }
      `}</style>
    </nav>
  );
}
